<!--
 * @Author: awu
 * @Date: 2020-11-14 16:24:34
 * @LastEditors: awu
 * @LastEditTime: 2020-12-08 23:41:37
 * @Description: 产品介绍详情
-->
<template>
    <div class="detail">
        <div class="backHome" :class="{ backActive: backFlag }" @click="backHome" @mouseenter="backFlag = true" @mouseleave="backFlag = false">
            <img src="../../assets/user/close.png" alt="" />
        </div>
        <img
            class="goBack"
            src="../../assets/area/back.png"
            @click="goBack"
            alt=""
            @mouseenter="leftBackFlag = true"
            @mouseleave="leftBackFlag = false"
            :class="{ backActive: leftBackFlag }"
        />
        <div class="boxTop">
            <div class="left">
                <img class="imgWarpper" :src="bigImgPath" alt="" />
                <div class="swiperBox">
                    <swiper class="swiper" ref="mySwiper" :options="swiperOptions">
                        <swiper-slide v-for="(item, index) in swiperSlide" :key="index">
                            <div class="box">
                                <img :src="item.url" alt="" @click="chooseImg(item, index)" :class="{ opcity: opcityFlag !== index }" />
                            </div>
                        </swiper-slide>
                    </swiper>
                    <div class="swiper-button-prev prev" @click="prev()" slot="button-prev">
                        <img v-show="leftArrowFlag" src="../../assets/left.png" alt="" />
                        <img v-show="!leftArrowFlag" src="../../assets/noLeft.png" alt="" />
                    </div>
                    <div class="swiper-button-next next" @click="next()" slot="button-next">
                        <img v-show="rightArrowFlag" src="../../assets/right.png" alt="" />
                        <img v-show="!rightArrowFlag" src="../../assets/noRight.png" alt="" />
                    </div>
                </div>
            </div>
            <div class="right">
                <h2>
                    <span style="font-weight: 500">{{ name }}</span>
                    <template v-if="is_store == 0">
                        <img @click="collect()" src="../../assets/collect.png" alt="" />
                        <span class="text">收藏</span>
                    </template>
                    <template v-if="is_store == 1">
                        <img @click="cancelCollect()" src="../../assets/collectActive.png" alt="" />
                        <span class="text">已收藏</span>
                    </template>
                </h2>
                <h3>{{ gsName }}</h3>
                <h4>{{ detail.parameter }}</h4>
                <div class="msg">
                    <span>{{ detail.msg1 }}</span
                    ><span>{{ price_low }}~{{ price_high }}</span>
                </div>
                <div class="msg">
                    <span>{{ detail.msg2 }}</span
                    ><span>{{ brand }}</span>
                </div>
                <div class="msg">
                    <span>{{ detail.msg3 }}</span
                    ><span>{{ model }}</span>
                </div>
                <div class="msg">
                    <span>{{ detail.msg4 }}</span
                    ><span>{{ specification }}</span>
                </div>
                <div class="msg">
                    <span>{{ detail.msg5 }}</span
                    ><span>{{ technical_parameter }}</span>
                </div>
            </div>
        </div>
        <div class="boxBot">
            <h2>{{ detail.introduction }}</h2>
            <p>{{ info }}</p>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import api from "@/api";
// import { exhibition_id } from "@/utils/exhibitId";
import Lockr from "lockr";
export default {
    props: ["exhibition_productId", "companyId","exhibitionId"],
    data() {
        return {
            swiperOptions: {
                //设置点击箭头
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev",
                    disabledClass: "my-button-disabled"
                },
                loop: false,
                slidesPerView: 3,
                lidesPerGroup: 2
            },
            slideNum: 3,
            leftArrowFlag: false,
            rightArrowFlag: false,
            swiperSlide: [],
            bigImgPath: "",
            opcityFlag: 0,
            backFlag: false,
            leftBackFlag: false,
            collectFlag: "",
            is_store: 0,
            id: null,
            company_id: null,
            exhibition_id: null,
            exhibition_product_id: "",
            name: "", //产品名称
            info: "", //简介
            gsName: "", //公司名称
            price_high: "", //最高价格
            price_low: "", //最低价格
            model: "", //品牌型号
            technical_parameter: "", //技术参数
            specification: "", //产品规格
            brand: "" //品牌名称
        };
    },
    mounted() {
        this.company_id = this.companyId 
        this.exhibition_id = this.exhibitionId
        this.exhibition_product_id = this.exhibition_productId
        this.getProductDetail();
    },
    methods: {
        getProductDetail() {
            api.getProductDetail({
                id: this.exhibition_product_id || Lockr.get("productId"),
                params: {
                    exhibition_id: this.exhibition_id,
                    company_id: this.company_id
                }
            }).then((res) => {
                if (res.res == 1) {
                    this.id = res.info.id;
                    this.is_store = res.info.is_store;
                    this.name = res.info.product.cn.name;
                    this.info = res.info.product.cn.info;
                    this.swiperSlide = res.info.product.cn.sub_images;
                    this.gsName = res.info.company.name;
                    this.price_low = res.info.product.price_low;
                    this.price_high = res.info.product.price_high;
                    this.model = res.info.product.model;
                    this.technical_parameter = res.info.product.cn.technical_parameter;
                    this.specification = res.info.product.cn.specification;
                    this.brand = res.info.product.cn.brand;
                }
            });
        },

        // 上一张
        prev() {
            this.swiper.slidePrev();
            this.slideNum--;
            if (this.slideNum <= 3) {
                this.slideNum = 3;
            }
        },
        // 下一张
        next() {
            this.swiper.slideNext();
            this.slideNum++;
            if (this.slideNum >= this.swiperSlide.length) {
                this.slideNum = this.swiperSlide.length;
            }
        },
        // 选择照片
        chooseImg(item, index) {
            this.bigImgPath = item.url;
            this.opcityFlag = index;
        },
        // 收藏
        collect() {
            if(!this.userInfo.id) {
                this.$message({
                    type: 'warning',
                    message: '请先登录后再收藏'
                })
                return
            }else {api.isCollectProduct({
                exhibition_product_id: this.id
            }).then((res) => {
                console.log(res);
                if (res.res == 1) {
                    this.is_store = 1;
                    this.$message.success("收藏成功")
                }
            });}
            
        },
        // 取消收藏
        cancelCollect() {
            api.noCollectProduct({
                exhibition_product_id: this.id
            }).then((res) => {
                console.log(res);
                if (res.res == 1) {
                    this.is_store = 0;
                    this.$message.success("取消收藏")
                }
            });
        },
        backHome() {
            // 个人中心 - 产品详情
            this.$root.$emit("close");
            this.$emit("cancel", 7);
        },
        goBack() {
            this.$emit("cancel", 7);
            this.$emit("show", 3);
        }
    },
    computed: {
        swiper() {
            return this.$refs.mySwiper.$swiper;
        },
        detail() {
            return this.$t("detail");
        },
        ...mapState(["userInfo","language"]),
    },
    watch: {
        slideNum(value) {
            if (value <= 3) {
                this.leftArrowFlag = false;
            }
            this.leftArrowFlag = value <= 3 ? false : true;
            this.rightArrowFlag = value >= this.swiperSlide.length ? false : true;
        },
        swiperSlide(value) {
            this.bigImgPath = value[0].url;
            if (value.length <= 3) {
                this.leftArrowFlag = false;
                this.rightArrowFlag = false;
            } else {
                this.leftArrowFlag = false;
                this.rightArrowFlag = true;
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.detail {
    height: 500px;
    width: 700px;
    background-color: #ffffff;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    box-shadow: 0px 8px 10px 4px rgba(0, 0, 0, 0.3);
    border-radius: 30px;
    box-sizing: border-box;
    padding: 61px 22px 0px 27px;
    .boxTop {
        width: 100%;
        // height: 229px;
        display: flex;
        align-items: flex-start;
        margin-bottom: 19px;
        .left {
            width: 253px;
            height: 100%;
            .imgWarpper {
                width: 100%;
                height: 173px;
                margin-bottom: 13px;
            }
            .swiperBox {
                width: 100%;
                height: 40px;
                position: relative;
                cursor: pointer;
                .swiper {
                    width: 216px;
                    height: 100%;
                    .box {
                        width: 59px;
                        height: 40px;
                        background: #d8d8d8;
                        border-radius: 5px;
                        margin: 0 auto;
                        > img {
                            width: 100%;
                            height: 100%;
                        }
                        .opcity {
                            opacity: 0.5;
                        }
                    }
                }
                .prev {
                    position: absolute;
                    left: 5px;
                    width: 0;
                    img {
                        width: 11px;
                    }
                }
                .next {
                    position: absolute;
                    right: 5px;
                    width: 0;
                    img {
                        width: 11px;
                    }
                }
            }
        }
        .right {
            margin-left: 13px;
            > h2 {
                // height: 22px;
                line-height: 22px;
                display: flex;
                align-items: center;
                font-size: 20px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #09468c;
                img {
                    width: 20px;
                    height: 20px;
                    margin: 0 7px 0 13px;
                    cursor: pointer;
                }
                .text {
                    font-size: 11px;
                    font-weight: 400;
                    color: #9ba2af;
                    line-height: 15px;
                }
            }
            > h3 {
                height: 17px;
                font-size: 12px;
                font-weight: 400;
                // color: #c6d4e5;
                line-height: 17px;
                margin: 7px 0 13px;
            }
            > h4 {
                height: 22px;
                font-size: 16px;
                font-weight: 500;
                color: #09468c;
                line-height: 22px;
                margin-bottom: 7px;
            }
            .msg {
                height: 17px;
                font-size: 12px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                // color: #c6d4e5;
                line-height: 17px;
            }
        }
    }
    .boxBot {
        width: 100%;
        height: 500px;
        overflow: auto;
        > h2 {
            height: 22px;
            font-size: 16px;
            font-weight: 500;
            color: #09468c;
            line-height: 22px;
            margin-bottom: 5px;
        }
        > p {
            font-size: 13px;
            font-weight: 400;
            // color: #c6d4e5;
            line-height: 17px;
        }
    }
}
.backHome {
    width: 33px;
    height: 33px;
    position: absolute;
    top: 21px;
    right: 21px;
    border-radius: 50%;
    cursor: pointer;
    > img {
        width: 100%;
        height: 100%;
    }
}
.backActive {
    background-color: #e8eef4;
}
.goBack {
    width: 32px;
    height: 32px;
    // background: #4F8AF8;
    border-radius: 50%;
    position: absolute;
    left: 15px;
    top: 15px;
    cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/views/product/detail.vue